// lib/supabase.js - Shared Supabase client instance
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Create a single shared Supabase client instance
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
